import styled from 'styled-components';
// css书写规范：定位/显示 > 盒模型 > 排版 > 外观 > mixin
const Root = styled.div `
`;
const Body = styled.div `
`;
const BodyTop = styled.div `
    .top__line-fir {
      color: #999999;
    }
    .topLine{
      border: 1px solid #bfbfbf;
      border-bottom: none;
      padding: 17px 0 17px 20px;
    }
`;
const Line = styled.div `
    position: relative;
    margin-bottom: 24px;
    ${(props) => props.setMinHeight ? {
    minHeight: 56,
} : {}};
    .export {
      width: 88px;
	    height: 32px;
      background-color: #ffffff;
	    border: solid 1px #d7d7db;
    }
    .abs_hasExport {
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -16px;
    }
`;
const WhiteSpace = styled.div `
    height: ${(props) => props.h ? `${props.h}px` : '30px'};
`;
export { Root, Body, BodyTop, Line, WhiteSpace };
